

































































import SubmitBtn from "@/components/Common/SubmitBtn.vue";
import InsuranceCommissionList from "../list/InsuranceCommissionList.vue";
import OfferItemCommissionList from "../list/OfferItemCommissionList.vue";
import ServiceFeeCommissionList from "../list/ServiceFeeCommissionList.vue";
import AccommodationCommissionList from "../list/AccommodationCommissionList.vue";
import { differentialSubmissionApi } from "@/api/index";
import { Component, Vue, Prop, ModelSync } from "vue-property-decorator";

@Component({
  name: "unsettledSubmissionDialog",
  components: {
    SubmitBtn,
    InsuranceCommissionList,
    OfferItemCommissionList,
    ServiceFeeCommissionList,
    AccommodationCommissionList,
  },
})
export default class extends Vue {
  @ModelSync("dialogTableVisible", "changeVisible", { type: Boolean })
  public value!: boolean;

  @Prop() public readonly data!: any;
  @Prop() public readonly isDifferentialSubmit!: boolean;

  public remark: string = "";
  public activeTab: string = "offerItem";
  public isSubmitted: boolean = false;

  public handleSubmit() {
    if (this.isDifferentialSubmit) {
      this.differentialSubmit();
    } else {
      this.settledSubmit();
    }
  }
  // 确认结算
  public settledSubmit() {
    const params = {
      remark: this.remark,
      offerItem: this.data.offerItem,
      insurance: [], // this.data.insurance,
      accommodation: [], // this.data.accommodation,
      serviceFee: [], // this.data.serviceFee,
    }
    this.handleClose();
    this.$emit("submitSettled", params);
  }
  // 差异提交
  public differentialSubmit() {
    if (this.remark.trim() === "") {
      this.$message.warning(this.$t("index.pleaseEnterRemark") as string);
      return;
    }
    this.$confirm(
      this.$t("message.differentialSubmissionConfirm") as string,
      "",
      {
        confirmButtonText: this.$t("common.confirm") as string,
        cancelButtonText: this.$t("common.cancel") as string,
        type: "warning",
      }
    )
    .then(async () => {
      try {
        this.isSubmitted = true;
        const params = {
          remark: this.remark,
          studentOfferItemCommissionDtoList: this.data.offerItem,
          // 暂时只需要留学申请部分
          studentInsuranceCommissionDtoList: [], // this.data.insurance,
          studentAccommodationCommissionDtoList: [], // this.data.accommodation,
          studentServiceFeeCommissionDtoList: [] // this.data.serviceFee,
        };
        await differentialSubmissionApi(params);
        const dateTime = new Date().getTime();
        this.$emit("set-time", dateTime);
        this.handleClose();
      } catch (err) {
        this.isSubmitted = false;
      }
    })
    .catch(() => {
      this.$message.info(this.$t("common.cancelled") as string);
    });
  }

  public handleTabClick($event: any) {
    const dataset = $event.target.dataset;
    if (dataset.tab) {
      this.activeTab = dataset.tab;
    }
  }

  public handleClose() {
    if (this.isSubmitted) {
      this.$emit('update-data')
    }
    this.isSubmitted = false;
    this.remark = "";
    this.activeTab = "offerItem";
    this.$emit("changeVisible", false);
  }
}
